/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Apikey_Cleared1Inputs */

const id_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API berhasil dihapus!`)
};

const ms_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API berjaya dikosongkan!`)
};

const da_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API nøgle ryddet succesfuldt!`)
};

const de_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel erfolgreich gelöscht!`)
};

const en_us2_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

const es_es2_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Clave de API borrada correctamente!`)
};

const es_mx2_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡API key borrada exitosamente!`)
};

const fil_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matagumpay na na-clear ang API key!`)
};

const fr_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé API effacée avec succès !`)
};

const it_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave API cancellata con successo!`)
};

const hu_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API kulcs sikeresen törölve!`)
};

const nl_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-sleutel succesvol gewist!`)
};

const no_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nøkkel fjernet!`)
};

const pl_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klucz API wyczyszczony pomyślnie!`)
};

const pt_br2_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

const pt_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave de API limpa com sucesso!`)
};

const ro_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheia API a fost ștearsă cu succes!`)
};

const fi_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-avain tyhjennetty onnistuneesti!`)
};

const sv_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-nyckel rensad!`)
};

const vi_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xóa khóa API thành công!`)
};

const tr_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API anahtarı başarıyla temizlendi!`)
};

const cs_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API klíč úspěšně vymazán!`)
};

const bg_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API ключът е изчистен успешно!`)
};

const ru_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ успешно очищен!`)
};

const uk_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-ключ успішно очищено!`)
};

const ar_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم مسح مفتاح API بنجاح!`)
};

const hi_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API कुंजी सफलतापूर्वक साफ़ की गई!`)
};

const th_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล้างคีย์ API สำเร็จ!`)
};

const ja_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API キーをクリアしました！`)
};

const zh_cn2_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

const zh_hant1_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

const ko_notifications_apikey_cleared1 = /** @type {(inputs: Notifications_Apikey_Cleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key cleared successfully!`)
};

/**
* | output |
* | --- |
* | "API key cleared successfully!" |
*
* @param {Notifications_Apikey_Cleared1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_apikey_cleared1 = /** @type {((inputs?: Notifications_Apikey_Cleared1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Apikey_Cleared1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_apikey_cleared1(inputs)
	if (locale === "ms") return ms_notifications_apikey_cleared1(inputs)
	if (locale === "da") return da_notifications_apikey_cleared1(inputs)
	if (locale === "de") return de_notifications_apikey_cleared1(inputs)
	if (locale === "en-US") return en_us2_notifications_apikey_cleared1(inputs)
	if (locale === "es-ES") return es_es2_notifications_apikey_cleared1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_apikey_cleared1(inputs)
	if (locale === "fil") return fil_notifications_apikey_cleared1(inputs)
	if (locale === "fr") return fr_notifications_apikey_cleared1(inputs)
	if (locale === "it") return it_notifications_apikey_cleared1(inputs)
	if (locale === "hu") return hu_notifications_apikey_cleared1(inputs)
	if (locale === "nl") return nl_notifications_apikey_cleared1(inputs)
	if (locale === "no") return no_notifications_apikey_cleared1(inputs)
	if (locale === "pl") return pl_notifications_apikey_cleared1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_apikey_cleared1(inputs)
	if (locale === "pt") return pt_notifications_apikey_cleared1(inputs)
	if (locale === "ro") return ro_notifications_apikey_cleared1(inputs)
	if (locale === "fi") return fi_notifications_apikey_cleared1(inputs)
	if (locale === "sv") return sv_notifications_apikey_cleared1(inputs)
	if (locale === "vi") return vi_notifications_apikey_cleared1(inputs)
	if (locale === "tr") return tr_notifications_apikey_cleared1(inputs)
	if (locale === "cs") return cs_notifications_apikey_cleared1(inputs)
	if (locale === "bg") return bg_notifications_apikey_cleared1(inputs)
	if (locale === "ru") return ru_notifications_apikey_cleared1(inputs)
	if (locale === "uk") return uk_notifications_apikey_cleared1(inputs)
	if (locale === "ar") return ar_notifications_apikey_cleared1(inputs)
	if (locale === "hi") return hi_notifications_apikey_cleared1(inputs)
	if (locale === "th") return th_notifications_apikey_cleared1(inputs)
	if (locale === "ja") return ja_notifications_apikey_cleared1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_apikey_cleared1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_apikey_cleared1(inputs)
	return ko_notifications_apikey_cleared1(inputs)
});
export { notifications_apikey_cleared1 as "notifications.apiKey.cleared" }